var React = require('react');

function SPrint18 (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("polygon",{"fill":"#707070","fillRule":"nonzero","points":"13 14 5 14 5 13 13 13","key":0}),React.createElement("polygon",{"fill":"#707070","fillRule":"nonzero","points":"13 12 5 12 5 11 13 11","key":1}),React.createElement("path",{"fill":"#707070","fillRule":"nonzero","d":"M17.5,5 L15,5 L15,1.5 C15,1.2236 14.7754,1 14.5,1 L3.5,1 C3.2246,1 3,1.2236 3,1.5 L3,5 L0.5,5 C0.2246,5 0,5.2236 0,5.5 L0,12.5 C0,12.7764 0.2246,13 0.5,13 L2,13 L2,16.5 C2,16.7764 2.2246,17 2.5,17 L15.5,17 C15.7754,17 16,16.7764 16,16.5 L16,13 L17.5,13 C17.7754,13 18,12.7764 18,12.5 L18,5.5 C18,5.2236 17.7754,5 17.5,5 Z M4,2 L14,2 L14,5 L4,5 L4,2 Z M15,16 L3,16 L3,10 L15,10 L15,16 Z","key":2})]));
}

SPrint18.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SPrint18;

SPrint18.default = SPrint18;
